import { BaseLookupModel, PaginationFilterRequest } from "./core.model";
import { utcToJSDate } from "@/utils/date-time";

/// <summary>Never Direct here — the admin API guarantees Kind != Direct (spec C-4).</summary>
export enum ChannelKind {
    Direct = 1,
    Club = 2,
    Event = 3,
}

export const ChannelKindList = [
    { value: ChannelKind.Club, label: "Club" },
    { value: ChannelKind.Event, label: "Event" },
];

export enum ChannelVisibility {
    Public = 1,
    Private = 2
}

export const ChannelVisibilityList = [
    { value: ChannelVisibility.Public, label: "Public" },
    { value: ChannelVisibility.Private, label: "Private" },
];

export enum ChannelStatus {
    Active = 1,
    Archived = 2
}

export const ChannelStatusList = [
    { value: ChannelStatus.Active, label: "Active" },
    { value: ChannelStatus.Archived, label: "Archived" },
];

export function channelFromJson(json: any): Channel {
    return {
        ...json,
        lastMessageAt: utcToJSDate(json.lastMessageAt)
    } as Channel;
};

export interface Channel {
    id: number;
    name?: string;
    kind: ChannelKind;
    visibility: ChannelVisibility;
    status: ChannelStatus;
    runningClub?: BaseLookupModel;
    runningClubEvent?: BaseLookupModel;
    messageCount: number;
    lastMessageAt?: Date;
    createdAt: string;
}

export class ChannelPaginationFilterRequest extends PaginationFilterRequest {
    runningClubId?: number;
    kind?: ChannelKind;
    runningClubEventId?: number;
}
